import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex justify-between items-center col-span-12 mb-5" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex justify-between items-center p-4 border" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "hidden md:flex" }
const _hoisted_8 = { class: "text-gray-400 text-center p-3" }
const _hoisted_9 = { class: "md:flex items-center gap-3" }
const _hoisted_10 = { class: "header-name-table" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex gap-3 items-center" }
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 0,
  class: "flex justify-end items-center"
}
const _hoisted_15 = { class: "mb-2 text-sm font-bold" }
const _hoisted_16 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_17 = {
  key: 1,
  class: "flex gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        class: "grid grid-cols-12 gap-8 text-black"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Selecionar usuários",
              en: "Select users",
            })), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              id: "back-class-btn",
              label: _ctx.$t('labels.back'),
              class: "btn-outline p-button-sm",
              onClick: _ctx.backStep
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_Button, {
              id: "save-class-btn",
              label: _ctx.$t('labels.save'),
              type: "submit",
              class: "btn-primary p-button-sm",
              loading: _ctx.loading,
              disabled: _ctx.loading
            }, null, 8, ["label", "loading", "disabled"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`bg-white col-span-12 rounded-lg ${
          _ctx.v$.selected.$error ? 'border border-red-500 overflow-hidden' : ''
        }`)
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.filters.isCleareable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    label: "Limpar",
                    icon: "pi pi-times",
                    class: "btn-outline p-button-sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter()))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.selectAll,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectAll) = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAllUsers())),
                binary: true
              }, null, 8, ["modelValue"]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Selecionar toda a página",
                  en: "Select all page",
                })), 1)
            ])
          ]),
          _createVNode(_component_DataTable, {
            value: _ctx.users,
            loading: _ctx.loading,
            showGridlines: ""
          }, {
            empty: _withCtx(() => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Dados não encontrados",
                  en: "Data not found",
                })), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  key: col.value,
                  field: col.value
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(col.name), 1),
                      (col.filter)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(`pi pi-filter text-white cursor-pointer hover:scale-125`),
                            onClick: ($event: any) => (_ctx.toggleFilter($event, col.value))
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_12, [
                      (col.value === 'name')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            modelValue: _ctx.selected,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
                            inputId: slotProps.data.id,
                            value: slotProps.data.id,
                            class: "col-span-2 checkbox-secondary"
                          }, null, 8, ["modelValue", "inputId", "value"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", {
                        for: slotProps.data.id,
                        class: "body-name-table hover:opacity-80 cursor-pointer"
                      }, _toDisplayString(slotProps.data[col.value]), 9, _hoisted_13)
                    ])
                  ]),
                  _: 2
                }, 1032, ["field"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "loading"]),
          (_ctx.courseParams?.total! > _ctx.courseParams?.size)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_Paginator, {
                  rows: _ctx.courseParams?.size,
                  totalRecords: _ctx.courseParams?.total,
                  rowsPerPageOptions: [10, 20, 30],
                  onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paginate($event)))
                }, null, 8, ["rows", "totalRecords"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode(_component_Errors, {
          class: "col-span-12",
          errors: _ctx.v$.selected.$errors
        }, null, 8, ["errors"])
      ], 32)
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "filter",
      style: {"min-width":"200px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterFor && _ctx.filterFor(...args)), ["prevent"]))
        }, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Pesquisar por:",
            en: "Search for:",
          })), 1),
          (_ctx.filterType == 'name')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.courseParams.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.courseParams.name) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-search",
                  class: "btn-primary !w-16",
                  type: "submit"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.filterType == 'login')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.courseParams.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.courseParams.email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-search",
                  class: "btn-primary !w-16",
                  type: "submit"
                })
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _: 1
    }, 512)
  ], 64))
}